import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
// import fileDownload from 'js-file-download';
//components
import PageTitle from "../../components/common/pageTitle";
import { Tiles, Content, ModalForms } from "../../components/transactionlist";
import { FormInputControl } from "../../components/common";
import Spinner from "../../shared/Spinner";
import { useSelector } from "react-redux";

//style
import style from "../../components/transactionlist/codeactive.module.scss";

import PaypalPayment from "../../components/Payments/PaypalPayment";
import Payments from "../../../service/common/PaymentApi";

//service
// import EwalletService from "../../../service/ewallet/Ewallet";

import TransactionListService from "../../../service/transactionList/TransactionList";

import UserStore from "../../../store/UserStore";

//data
import transactiondata from "./transactiondata.json";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import companyName from "../../../store/mobxStore/companyName";
import OrderService from "../../../service/orderHistory/orderHistory";
import TransactionListingPrintView from "./TransactionListingPrintView";

const mapStateToProps = (state) => ({ lang: state.Lang });

const CodeActivation = (props) => {
  const Currency = useSelector((state) => state.curr);

  const { t } = props;
  const [checkout, setCheckout] = useState(false);
  // let amount = 10;
  const [EwalletAmount, setEwalletAmount] = useState({
    amount: "",
    FormError: {
      amount: "",
    },
    isvalid: false,
  });
  const [printloader, setPrintLoader] = useState({
    EarningsTable: {
      search: false,
      reset: false,
      excel: false,
      csv: false,
      print: false,
    },
    HistoryTable: {
      search: false,
      reset: false,
    },
  });
  let service = new OrderService();
  let history = useHistory();
  const [state, setState] = useState({
    loading: true,
    data: [],
    totalRows: "",
    inPage: 1,
    perPage: 10,
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
  });
  // useEffect(() => {
  //   getOrders();
  // }, [state]);

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    getOrders();
  }, [state.start_date, state.end_date]);

  const getOrders = (inPage = state.inPage, perPage = state.perPage) => {
    let start = (inPage - 1) * perPage;
    service
      .getOrderHistory(start, perPage, state.start_date, state.end_date)
      .then((res) => {
        if (res.status) {
          console.log(" === inside get order history status ==== ");
          console.log(res.data.order_details);
          setState((prevState) => ({
            ...prevState,
            loading: false,
            data: res.data.order_details,
            totalRows: res.data.count,
            inPage: 1,
            perPage: 10,
          }));
        } else {
          if (res.error.code === 1002) {
            history.push("/logout");
          } else if (res.error.code === 1057) {
            history.push({
              pathname: "/dashboard",
              state: {
                error: true,
                message: "permissionDenied",
              },
            });
          }
        }
      });
  };

  const changeOrdersTable = (inPage, perPage) => {
    setState((prevState) => ({
      ...prevState,
      perPage: perPage,
      inPage: inPage,
    }));
    getOrders(inPage, perPage);
  };

  if (state.loading) {
    return <Spinner />;
  }

  const changeOrdersTabledate2 = (start, end) => {
    setState((prev) => ({
      ...prev,
      start_date: start,
      end_date: end,
    }));
  };
  const resetdata = () => {
    setState((prev) => ({
      ...prev,
      start_date: moment().startOf("month").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    }));
    getOrders();
  };
  const Translation = (data, tab) => {
    let newData;

    newData = data.map((item) => {
      console.log("itemsss", item);
      if (item) {
        return {
          ...item,
          // date_used: moment(item.date_used).format("MM-DD-YY"),
          gross: `${Currency.currentCurr}${(
            parseFloat(item.gross) * Currency.value
          ).toFixed(Currency.precision)}`,
        };
      } else return item;
    });

    return newData;
  };
  // Export Data
  const exportData = (
    startdate = "",
    enddate = "",
    categories = "",
    type,
    tab
  ) => {
    let keys = categories
      .map((key, idx) => {
        return "categories[" + idx + "]=" + key.value;
      })
      .join("&");

    service
      .getOrderHistoryExport(startdate, enddate, keys, type)
      .then((res) => {
        console.log("resexporttttt", res);
        if (type === "excel") {
          ExportToExcel(res.data.result, "Store Transaction History", type);
          setPrintLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            HistoryTable: {
              search: false,
              reset: false,
            },
          });
        }
        if (type === "csv") {
          ExportToExcel(res.data.result, "Store Transaction History", type);
          setPrintLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            HistoryTable: {
              search: false,
              reset: false,
            },
          });
        }

        if (type === "print") {
          ExportToExcel(res.data.result, "Store Transaction History", type);
        }
      });

    const ExportToExcel = (apiData, fileName, type, tab) => {
      console.log(`type ${type}`);
      let fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let fileExtension = ".xlsx";

      if (type === "excel") {
        console.log(" ==== excel data goes here ==== ");
        console.log(apiData);
        console.log(" ==== excel data goes here ==== ");
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Transaction Date",
            "Transaction No",
            "Transaction Type",
            "Gross",
            "Delivery Mode",
            "Delivery Address",
            "Payment Type",
            "Status",
            "Sales Invoice",
            "Tracking No",
            "Code Status"
          ],
        ]);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setPrintLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Transaction Date",
            "Transaction No",
            "Transaction Type",
            "Gross",
            "Delivery Mode",
            "Delivery Address",
            "Payment Type",
            "Status",
            "Sales Invoice",
            "Tracking No",
            "Code Status"
          ],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setPrintLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      } else {
        // let printView =
        //  <TransactionListingPrintView data={apiData} />;
        setPrintLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
    };
  };

  return (
    <div className={`h-100`}>
      <Helmet>
        <title>
          {companyName.companyName} | {t("Sidemenu.transactionListing")}
        </title>
      </Helmet>
      <PageTitle title="transactionListing" buttonOn={true} group={[]} />
      {state.loading ? (
        <Spinner />
      ) : (
        <div className={style.MainContainer} style={{ marginTop: "0px" }}>
          <Content
            tableData={state}
            loader={state.loading}
            changeOrdersTable={changeOrdersTable}
            datehandler={changeOrdersTabledate2}
            resetdata={resetdata}
            exportData={exportData}
            // datehandler={changeOrdersTabledate}
            printloader={printloader}
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation()(
  connect(mapStateToProps)(withRouter(CodeActivation))
);
